import { render, staticRenderFns } from "./IntroResearch.vue?vue&type=template&id=9149d190&scoped=true"
import script from "./IntroResearch.vue?vue&type=script&lang=js"
export * from "./IntroResearch.vue?vue&type=script&lang=js"
import style0 from "./IntroResearch.vue?vue&type=style&index=0&id=9149d190&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9149d190",
  null
  
)

export default component.exports